/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notify_DeniedInputs */

const en_notify_denied = /** @type {(inputs: Notify_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications are blocked for Dishly. Allow them in the device settings.`)
};

const de_notify_denied = /** @type {(inputs: Notify_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitteilungen sind für Dishly blockiert. Erlaube sie in den Einstellungen des Geräts.`)
};

/**
* | output |
* | --- |
* | "Notifications are blocked for Dishly. Allow them in the device settings." |
*
* @param {Notify_DeniedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_denied = /** @type {((inputs?: Notify_DeniedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_DeniedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_denied(inputs)
	return en_notify_denied(inputs)
});